// BL-177 Step 2g (item 5): the company a page should NAME ("Grey items are turned off for The Ride ..."), not the tenant.
// orgs.name is the tenant (e.g. "VWH"); the company people know comes from Brands & Locations (the entities tree), the same
// way staff alerts resolve it (resolveCompanyBrandDetail). On The Ride's own address it is The Ride's company row.
import branding from '../config/signInBranding.json';
import { resolveCompanyBrandDetail } from './alertCopy';

const text = (value) => (typeof value === 'string' ? value.trim() : '');

export function isRideHostname(hostname) {
    return (branding.hostnames['the-ride-atl'] || []).includes(String(hostname || '').toLowerCase());
}

/** The company name to show. Falls back to the tenant name only when Brands & Locations has nothing to say. */
export function resolveCurrentCompanyName({ entities = [], orgName = '', hostname = '' } = {}) {
    const rows = Array.isArray(entities) ? entities : [];
    if (isRideHostname(hostname)) {
        const ride = rows.find((row) => row && row.id === branding.companyEntityId);
        const rideName = text(ride && ride.brand_name) || text(ride && ride.name);
        if (rideName) return rideName;
    }
    return text(resolveCompanyBrandDetail({ entities: rows }).companyName) || text(orgName);
}

/** Loads the entities tree (and, as the last resort, the tenant name) and resolves the name. Never throws. */
export async function loadCurrentCompanyName(client, orgId, hostname = globalThis.location?.hostname || '') {
    if (!client || !orgId) return '';
    let entities = [];
    let orgName = '';
    try {
        const { data } = await client.from('entities').select('id, parent_entity_id, level_type, name, brand_name, logo').eq('org_id', orgId);
        entities = Array.isArray(data) ? data : [];
    } catch (failure) {
        entities = [];
    }
    if (!entities.length) {
        try {
            const { data } = await client.from('orgs').select('name').eq('id', orgId).maybeSingle();
            orgName = text(data && data.name);
        } catch (failure) {
            orgName = '';
        }
    }
    return resolveCurrentCompanyName({ entities, orgName, hostname });
}
